<template>
	<div>
		<div class="content">
			<div class="top">
				<div id="Dynamic">
					<!-- 轮播图区域 -->
					<div class="banner_div">
						<el-carousel :interval="interval" trigger="click" style="height:710px;">
							<el-carousel-item v-for="item in list1" :key="item.id" style="height:710px;">
								<el-row style="height:710px;">
									<el-col :span="24">
										<div class="swiper-slide" :lazy="item.src">
											<a :href="item.url">
												<img ref="bannerimg" :src="item.src" :alt="item.id" height="710" width="100%">
											</a>
										</div>
									</el-col>
								</el-row>
							</el-carousel-item>
						</el-carousel>
					</div>
				</div>
				<div :class="[xian?'xian':'xian1']">
					<div class="content1">
						<ul>
							<li>
								<i class="iconfont icon-home2"></i><a href="/" class="hover">  首页</a>
							</li>
							<li>
								/
							</li>
							<li class="hover" v-if="name==''" @click="login()">
								请登录
							</li>
							<li class="hover" v-else>
								您好：{{name}}
							</li>
							<li>
								/
							</li>
							<li class="hover" v-if="name==''" @click="register()">
								注册
							</li>
							<li class="hover" v-else @click="quit">
								退出
							</li>
						</ul>
						<ul>
							<li class="hover" @click="user_order">
								查询订单
							</li>
							<li>
								/
							</li>
							<li v-on:mouseover="handleOver($event)" v-on:mouseout="handleOut($event)">
								<a href="" class="hover" @click="user">
									会员中心 
									<span>
										<img src="../assets/img1/sy/SANJIAOX.png"/>
									</span>
								</a>
								<div class="show" v-show="flag">
									<ul>
										<li @click="user">
											会员中心
										</li>
										<li>
											<a rel="nofollow" href="javascript:;" @click="user_order">我的订单</a>
										</li>
										<li>
											<a rel="nofollow" href="javascript:;" @click="user_fav">我的收藏</a>
										</li>
										<li>
											<a rel="nofollow" href="javascript:;" @click="user_coupon">我的优惠券</a>
										</li>
										<li>
											<a rel="nofollow" href="javascript:;" @click="user_address">收货地址</a>
										</li>
									</ul>
								</div>
							</li>
							<li>
								/
							</li>
							<li class="hover" v-on:mouseover="handleOver1($event)" v-on:mouseout="handleOut1($event)">
								手机版
								<div class="sm" v-show="flag1">
									手机版
									<img src="../assets/img1/sy/sm.png"/>
								</div>
							</li>
							<li>
								/
							</li>
							<li v-on:mouseover="handleOver2($event)" v-on:mouseout="handleOut2($event)" @click="help">
								<a href="" class="hover">
									帮助中心
									<span>
										<img src="../assets/img1/sy/SANJIAOX.png"/>
									</span>
								</a>
								<div class="show2" v-show="flag2">
									<ul>
										<li @click="help">
											<a rel="nofollow" href="">帮助中心</a>
										</li>
										<li>
											<a rel="nofollow" href="/help/fangshi">如何订购</a>
										</li>
										<li>
											<a rel="nofollow" href="/help/huodaofukuan">货到付款</a>
										</li>
										<li>
											<a rel="nofollow" href="/help/zaixian">在线支付</a>
										</li>
										<li>
											<a rel="nofollow" href="/help/dianhuadinggou">电话订购</a>
										</li>
										<li>
											<a rel="nofollow" href="/help/kefu">客服中心</a>
										</li>
									</ul>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="content2">
					<div>
						<div>
							<ul>
								<li>
									<a href="/">
										<img src="../assets/img1/sy/tubiao.png"/>
									</a>
								</li>
								<li>
									夜 樱
								</li>
							</ul>
						</div>
						<div>
							<div>
								<input type="text" id="keywords" name="keywords" v-model="keywords" class="shl left" placeholder="想买什么，搜一搜，如避孕套" onfocus ="if(placeholder=='想买什么，搜一搜，如避孕套') {placeholder=''}" onblur ="if (placeholder=='') {placeholder='想买什么，搜一搜，如避孕套'}" @keyup.enter.prevent="searchEnterFun($event)"/>
								<span @click="search(keywords)">
									<img src="../assets/img1/sy/SHOUSHUO.png"/>
								</span>
							 	<!-- <div id="rec_results" class="g-rec-results" v-show="msgShow">
							 	<ul class="history-results">
							 		<li class="title gray"><span>搜索历史</span></li>
							 		<li class="history">
							 			<a tabindex="-1" target="_blank" href="">飞机杯</a>
							 		</li>
							 		<li class="history">
							 			<a tabindex="-1" target="_blank" href="">女优娃娃</a>
							 		</li>
							 	</ul>
							 	<ul class="rec-results">
							 		<li class="title gray">
							 			<span>精选推荐</span>
							 		</li>
							 		<li>
							 			<a tabindex="-1" target="_blank" href="">飞机杯</a>
							 		</li>
							 		<li>
							 			<a tabindex="-1" target="_blank" href="">女优娃娃</a>
							</li>
							</ul>
							</div> -->
								<div class="gwc" id="tcar">
									<a class="t_c" @click="buycar">
										购物车
										<p id="qcar">{{number}}</p>
										<i class="gwc-i">&gt;</i>
									</a>
								</div>
							</div>
							<div class="hot">
								<p class="hot1">
									<span>
										<router-link :to="{path:'/shop/shopsearch?cate_id=13'}" target="_blank">
											仿真阳具
										</router-link>
									</span>
									<em class="vline1">|</em>
									<span>
										<router-link :to="{path:'/shop/shopsearch?cate_id=10'}" target="_blank">
											阴臀倒模
										</router-link>
									</span>
									<em class="vline1">|</em>
									<span>
										<router-link :to="{path:'/shop/shopsearch?cate_id=22'}" target="_blank">
											外用延时
										</router-link>
									</span>
									<em class="vline1">|</em>
									<span>
										<router-link :to="{path:'/shop/shopsearch?cate_id=14'}" target="_blank">
											震动棒
										</router-link>
									</span>
									<em class="vline1">|</em>
									<span>
										<router-link :to="{path:'/shop/shopsearch?cate_id=6'}" target="_blank">
											飞机杯
										</router-link>
									</span>
									<em class="vline1">|</em>
									<span>
										<router-link :to="{path:'/shop/shopsearch?cate_id=33'}" target="_blank">
											阴蒂刺激
										</router-link>
									</span>
								</p>
							</div>
							<div class="hod">
								<ul>
									<li>
										<span class="hover"><a href="/">首页</a></span> <span class="sez">|</span>
									</li>
									<li v-for="(items,index) in category" :key="items.id" @click="catesearch(items.title,index)">
										<span class="hover">{{items.title}}</span> <span class="sez">|</span>
									</li>
									<li class="hover" @click="tiao">
										积分商城
									</li>
									<li>
										<span class="sez">|</span>
									</li>
									<li class="hover" @click="$router.push({path: '/article'})">
										两性百科
									</li>
									<!-- <li class="hover" @click="$router.push({path: '/life'})">
										两性百科
									</li> -->
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default{
	name: 'carrousel',
	components:{
	},
	data(){
		return{
			number:"",
			name: '',
			activeCode:"",
			activeMember:"",
			activeHelp:"",
			activeT:"",
			msgShow:false,
			keywords:"",
			list:"",
			category:[],
			
            type: 1,
			flag:false,
			flag1:false,
			flag2:false,
			xian:false,
			//轮播图切换时间
            interval:3000,
            list1:[
                // {id:1,url:"",src:require('@/assets/img1/sy/LUNBOTU.png')},
                // {id:2,url:"/detail?id=392",src:require('@/assets/img1/sy/LUNBOTU2.png')},
                // {id:3,url:"/detail?id=341",src:require('@/assets/img1/sy/LUNBOTU3.png')},
                // {id:4,url:"/detail?id=288",src:require('@/assets/img1/sy/LUNBOTU4.png')},
				// {id:4,url:"/detail?id=254",src:require('@/assets/img1/sy/LUNBOTU5.png')}
				{id:1,url:"/detail?id=414",src:require('@/assets/picture/banner/banner1.jpg')},
                {id:2,url:"/detail?id=420",src:require('@/assets/picture/banner/banner2.jpg')},
                {id:3,url:"/detail?id=288",src:require('@/assets/picture/banner/banner3.jpg')},
                {id:4,url:"/detail?id=224",src:require('@/assets/picture/banner/banner4.jpg')},
                {id:5,url:"/detail?id=415",src:require('@/assets/picture/banner/banner5.jpg')}
            ],
		}
	},
	// created(){
	// }, 
	mounted(){
		this.getShopCate();
		this.cartList();
		/*页面挂载获取保存的localStorage值，渲染到页面上*/
        if(window.localStorage.getItem("user")){
            this.name = JSON.parse(window.localStorage.getItem("user")).nickname;
			// console.log(this.name)
        }

		//轮播图部分
		this.resetDocumentClientHeight()
        this.imgLoad();
        window.addEventListener('resize',() => {
            this.imgLoad();
        },false)

	},
	methods:{
		//跳转到商城
		tiao(){
			this.$router.push('/recharge')
			// this.$router.push('/login')
		},
		//购物车
		cartList(){
            var cart_params = {};
            cart_params.uid = JSON.parse(window.localStorage.getItem("user")).id;
            this.$api.getShop.getCartList(cart_params).then(res => {
                if (res.code == 200) {
                    this.list = [];
					// this.number = res.result[0].data.length;
					if(res.result[0].all_price == ""){
                        this.number = 0;
                    }else{
                        this.number = res.result[0].data.length;
						var arr = res.result[0].data;
						arr.forEach((item,i) => {
							this.list.push(item);
						});
                    }
                }
            });
        },
		//轮播图部分
		imgLoad(){
			this.$nextTick(()=>{
				let ref = this.$refs
			})
		},
		resetDocumentClientHeight(){
			var _that=this;
			window.onresize=()=>{
			}
		},
		//指定跳转登录地址
		login(){
			this.$router.push('/login')
		},
		//退出登录
		quit(){
			/*删除cookie*/
			/*localStorage.clear();
			sessionStorage.clear();*/
			this.$router.push({name:"Login"})
		},
		register(){
			//指定跳转地址
			this.$router.push('/login')
		},
		//查询订单
		user_order(){
			//指定跳转地址
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/user_order')
			}else{
				this.$router.push('/login')
			}
		},
		//会员中心
		user(){
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/user_infor')
			}else{
				this.$router.push('/login')
			}
		},
		//积分兑换
		user_grade(){
			//指定跳转地址
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/user_grade')
			}else{
				this.$router.push('/login')
			}
		},
		//帮助中心
		help(){
			//指定跳转地址
			this.$router.push('/help')
		},
		//我的订单
		user_order(){
			//指定跳转地址
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/user_order')
			}else{
				this.$router.push('/login')
			}
		},
		//收货地址
		user_address(){
			//指定跳转地址
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/user_address')
			}else{
				this.$router.push('/login')
			}
		},
		//我的收藏
		user_fav(){
			//指定跳转地址
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/user_fav')
			}else{
				this.$router.push('/login')
			}
		},
		//我的优惠券
		user_coupon(){
			//指定跳转地址
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/user_coupon')
			}else{
				this.$router.push('/login')
			}
		},
		//购物车
		buycar(){
			//指定跳转地址
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/car')
			}else{
				this.$router.push('/login')
			}
		},
		//搜索
		search(keywords){
			var params = {};
            params.keywords = keywords || "";
			//指定跳转地址
			this.$router.push({path:'/search',query:{keywords:params.keywords,showVideo:1}});
		},
		//设置搜索显示
		// tanchukuang(){
		// 	this.msgShow = true;
        // },
		 catesearch(title,index){
            if(index == 0){
                this.$router.push(`/woman/`);
            }else if(index == 1){
                this.$router.push(`/man/`);
            }else if(index == 2){
                this.$router.push(`/biyuntao/`);
            }else if(index == 3){
                this.$router.push(`/zhuxing/`);
            }else if(index == 4){
                this.$router.push(`/lingleiwanju/`);
            }else if(index == 5){
                this.$router.push(`/tehui/`);
            }
        },
		//回车事件搜索
		 searchEnterFun(e){
			var keyCode = window.event ? e.keyCode : e.which;
			if(this.keywords != ""){
				if (keyCode == 13) {
					this.search(this.keywords)
				}
			}else{
                this.$confirm('请输入要搜索的关键字', '提示', {
                    confirmButtonText: '确认', // 确认按钮文字更换
                    cancelButtonText: '取消', // 取消按钮文字更换
                    showClose: true, // 是否显示右上角关闭按钮
                    type: 'warning' // 提示类型  success/info/warning/error
		        })
            }
		},
		handleOver (e) {
			this.flag = true;
			this.xian = true;
		},
		handleOut (e) {
			this.flag = false;
			this.xian = false;
		},
		handleOver1 (e) {
			this.flag1 = true;
			this.xian = true;
		},
		handleOut1 (e) {
			this.flag1 = false;
			this.xian = false;
		},
		handleOver2 (e) {
			this.flag2 = true;
			this.xian = true;
		},
		handleOut2 (e) {
			this.flag2 = false;
			this.xian = false;
		},
		//api获取接口
		getShopCate() {
            this.$api.getCategory.getShopCate({}).then(res => {
                if (res.code == 200) {
                    this.category = [];
                    var arr = res.result.cate;
                    arr.forEach(item => {
                        if (item.show == 1) {
                            this.category.push(item);
                        }
                    });
                    this.type = res.result.types;
                }
            });
        },
	}
}
</script>

<style scoped>
	*{
		margin: 0;
		padding: 0;
	}
	.content{
		width: 100%;
		height: 710px;
		/*background: url(../assets/img1/sy/LUNBOTU4.png) no-repeat;
		background-size: 100% 700px;*/
	}
	.content .top{
		/* border: 1px solid black; */
		position: relative;
	}
	.xian{
		width: 100%;
		height: 40px;
		line-height: 40px;
		background:rgba(0, 0, 0, 0.8); 
		border-bottom: 1px solid #bf0f7b;
		position: absolute;
		top:0px;
		left: 0px auto;
		z-index: 999;
	}
	.xian1{
		width: 100%;
		height: 40px;
		line-height: 40px;
		background:rgba(0, 0, 0, 0.8); 
		border-bottom:1px solid black;
		position: absolute;
		top:0px;
		z-index: 999;
	}
	.content1{
		/* border: 1px solid red; */
		width: 1200px;
		height: 40px;
		line-height: 40px;
		display: flex;
		margin: auto;
		/* color: rgb(239, 239, 239); */
	}
	.content1>ul:nth-child(1){
		/* border: 1px solid yellow; */
		width: 300px;
	}
	.content1>ul:nth-child(1)>li{
		cursor: pointer;
		display: inline-block;
		margin-right: 5px;
		font-size: 16px;
	}
	.content1>ul:nth-child(1)>li:nth-child(1) img{
		width: 24px;
		margin-top: -7px;
	}
	.content1>ul:nth-child(2){
		/* border: 1px solid yellow; */
		flex: 1;
		text-align: right;
	}
	.content1>ul:nth-child(2)>li{
		cursor: pointer;
		display: inline-block;
		margin-right: 8px;
		font-size: 16px;
	}
	.content2{
		/* border: 1px solid red; */
		/* background: url(../assets/img1/TOUMING.png) no-repeat; 
		opacity: 0.8; */
		width: 100%;
		background:rgba(0, 0, 0, 0.5); 
		position: absolute;
		top:40px;
		z-index: 9;
	}
	.content2>div:nth-child(1){
		/* border: 1px solid red; */
		width: 1200px;
		height: 184px;
		/* line-height: 40px;*/
		margin: auto; 
		display: flex;
	}
	.content2>div:nth-child(1)>div:nth-child(1){
		/* border: 1px solid blue; */
		width: 200px;
		height: 100px;
		margin-left: 50px;
		margin-top: 60px;
	}
	.content2>div:nth-child(1)>div:nth-child(1)>ul:nth-child(1){
		cursor: pointer;
		display: inline;
		color: white;
	}
	.content2>div:nth-child(1)>div:nth-child(1)>ul:nth-child(1)>li:nth-child(1) img{
		width: 120px;
	}
	.content2>div:nth-child(1)>div:nth-child(1)>ul:nth-child(1)>li:nth-child(2){
		margin-top: 10px;
		margin-left: 35px;
		font-size: 21px;
	}
	.content2>div:nth-child(1)>div:nth-child(2){
		/* border: 1px solid blue; */
		flex: 1;
		height: 100px;
		margin-top: 60px;
	}
	.content2>div:nth-child(1)>div:nth-child(2)>div{
		position: relative;
	}
	.content2>div:nth-child(1)>div:nth-child(2)>div>input{
		border: 1px solid gray;
		width: 280px;
		height: 30px;
		margin-left: 490px;
		border-radius: 10px 0px 0px 10px;
		padding-left: 15px;
	}
	.content2>div:nth-child(1)>div:nth-child(2)>div>span{
		cursor: pointer;
		border: 1px solid gray;
		background-color: white;
		display: inline-block;
		width: 50px;
		height: 30px;
		position: absolute;
		right: 132px;
		top: 0px;
		line-height: 27px;
		text-align: center;
		border-radius: 0px 10px 10px 0px;
	}
	.shuliang{
		position: relative;
	}
	.shuliang>span{
		position: absolute;
		top: -32px;
		right: -24px;
		transform:scale(0.7,0.7)
	}
	.gwc>span{
		cursor: pointer;
		display: inline-block;
		color: white;
		/*margin-left: -58px;
		padding-top: 4px;*/
		position: absolute;
		right: 28px;
		top: 7px;
		transform:scale(0.8,0.8)
	} 
	.hod{
		margin-top: 24px;
	}
	.hod>ul{
		color: white;
		font-size: 16px;
		float: right;
		margin-top: 24px;
	}
	.hod>ul>li{
		cursor: pointer;
		display: inline-block;
	}
	.sez{
		margin-left: 10px;
		margin-right: 10px;
	}
	.show{
		position: absolute;
		z-index: 9999;
		border: 1px solid #bf0f7b;
		width: 90px;
		height: 135px;
		border-radius: 10px;
		background-color: #444341;
		font-size: 12px;
		text-align: center;
		line-height: 26px;
		margin-top: -30px;
	}
	.show>ul>li>a:hover{
		color: #bf0f7b;
	}
	.show>ul>li:nth-child(1){
		font-size: 16px;
	}
	.sm{
		position: absolute;
		z-index: 999;
		border: 1px solid #bf0f7b;
		width: 80px;
		height: 123px;
		border-radius: 10px;
		background-color: #444341;
		font-size: 16px;
		text-align: center;
		line-height: 26px;
		margin-top: -30px;
	}
	.sm>img{
		border-radius: 10px;
		width: 80px;
		margin-top: 6px;
	}
	.show2{
		position: absolute;
		z-index: 9999;
		border: 1px solid #bf0f7b;
		width: 100px;
		height: 160px;
		border-radius: 10px;
		background-color: #444341;
		font-size: 12px;
		text-align: center;
		line-height: 26px;
		margin-top: -30px;
	}
	.show2>ul>li>a:hover{
		color: #bf0f7b;
	}
	.show2>ul>li:nth-child(1){
		font-size: 16px;
	}
	.hover>a{
		color: white;
	}
	.hover:hover{
		color:  #c6148c;
	}
	.hover>a:hover{
		color:  #c6148c;
	}
	.hot{
		float: right;
		margin-right: 140px;
		color: white;
		margin-top: 7px;
	}
	.hot1 a{
		color: white;
	}
	.hot1 a:hover{
		color: #bf0f7b;
	}
	.gwc{
		display: inline-block;
		margin-left: 70px;
		position: relative;
		border-radius: 10px;
		width: 90px;
		height: 32px;
		background-color: white;
	}
	.t_c{
		padding-left: 30px;
		font-size: 12px;
	}
	.gwc-i{
		margin-left: 6px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Header1.vue